module.exports = __webpack_public_path__ + "static/media/points10_7.9d188776.png";